"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.deviceModelMobileView = exports.deviceModel = void 0;
var _DeviceWarranty = require("./DeviceWarranty");
var _Image = _interopRequireDefault(require("./../../../Components/Image/Image"));
var _jsxRuntime = require("react/jsx-runtime");
const deviceModel = (labels, data) => {
  var _data$img, _data$img2, _data$img3, _data$img4, _data$img5, _data$earSide, _data$earSide2, _data$earSide3, _data$earSide4;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "ccl-e-device-model__container",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {
      fluid: true,
      bgColor: "transparent",
      fallback: data == null || (_data$img = data.img) == null ? void 0 : _data$img.fallback,
      src: data == null || (_data$img2 = data.img) == null ? void 0 : _data$img2.src,
      alt: (data == null || (_data$img3 = data.img) == null ? void 0 : _data$img3.alt) || data.productDescription || '',
      width: (data == null || (_data$img4 = data.img) == null ? void 0 : _data$img4.width) || '50px',
      height: (data == null || (_data$img5 = data.img) == null ? void 0 : _data$img5.height) || '50px'
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-e-device-model__container__product",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "ccl-e-device-model__container__product__section ccl-e-device-model__container__product__section--title",
        children: data.productName
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "ccl-e-device-model__container__type",
      children: [(data == null || (_data$earSide = data.earSide) == null ? void 0 : _data$earSide.side) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `ccl-e-device-model__container__type__icon ccl-e-device-model__container__type__icon--${data == null || (_data$earSide2 = data.earSide) == null ? void 0 : _data$earSide2.side}`,
        children: labels[data == null || (_data$earSide3 = data.earSide) == null ? void 0 : _data$earSide3.abbrLabel]
      }), data == null || (_data$earSide4 = data.earSide) == null ? void 0 : _data$earSide4.text]
    })]
  });
};
exports.deviceModel = deviceModel;
const deviceModelMobileView = (labels, data) => {
  var _data$img6, _data$img7, _data$img8, _data$img9, _data$img10;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "ccl-e-device-model__container",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-e-device-model__container__img",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {
        fluid: true,
        bgColor: "transparent",
        fallback: data == null || (_data$img6 = data.img) == null ? void 0 : _data$img6.fallback,
        src: data == null || (_data$img7 = data.img) == null ? void 0 : _data$img7.src,
        alt: (data == null || (_data$img8 = data.img) == null ? void 0 : _data$img8.alt) || data.productDescription || '',
        width: (data == null || (_data$img9 = data.img) == null ? void 0 : _data$img9.width) || '75px',
        height: (data == null || (_data$img10 = data.img) == null ? void 0 : _data$img10.height) || '75px'
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-e-device-model__container__product",
      children: data.sections.map(({
        type,
        ...info
      }) => {
        switch (type) {
          case 'title':
            {
              var _info$;
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "ccl-e-device-model__container__product__section ccl-e-device-model__container__product__section--title",
                children: info.text
              }, `${type}-${(_info$ = info[1]) == null ? void 0 : _info$.value}`);
            }
          case 'text-pair':
            {
              var _info$2;
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "ccl-e-device-model__container__product__section",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "ccl-e-device-model__container__product__section__pair",
                  children: labels[info.keyLabel]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "ccl-e-device-model__container__product__section__pair",
                  children: info.value
                })]
              }, `${type}-${(_info$2 = info[1]) == null ? void 0 : _info$2.value}`);
            }
          case 'side-pair':
            {
              var _info$3;
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "ccl-e-device-model__container__product__section",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "ccl-e-device-model__container__product__section__pair",
                  children: labels[info.keyLabel]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "ccl-e-device-model__container__type",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: `ccl-e-device-model__container__type__icon ccl-e-device-model__container__type__icon--${info.side}`,
                    children: labels[info.abbrLabel]
                  }), info.value]
                })]
              }, `${type}-${(_info$3 = info[1]) == null ? void 0 : _info$3.value}`);
            }
          case 'warranty-pair':
            {
              var _info$4;
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "ccl-e-device-model__container__product__section ccl-e-device-model__container__product__section--detailed",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "ccl-e-device-model__container__product__section__pair",
                  children: labels[info.keyLabel]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "ccl-e-device-model__container__product__section__pair",
                  children: (0, _DeviceWarranty.deviceWarranty)(labels, info.value)
                })]
              }, `${type}-${(_info$4 = info[1]) == null ? void 0 : _info$4.value}`);
            }
          default:
            {
              return undefined;
            }
        }
      })
    })]
  });
};
exports.deviceModelMobileView = deviceModelMobileView;